import api from './api';
import { AxiosRequestConfig } from 'axios';

export const getAsync = <TResponse = any>(
    url: string,
    config?: AxiosRequestConfig<any>,
): Promise<APIResponse<TResponse>> => {
    return api.get(url, config);
};
